import React from "react";
import { Redirect } from "react-router-dom";
import Form from "./common/form";
import Button from '@material-ui/core/Button';
import { NavLink } from "react-router-dom";
import auth from "../services/authService";
import { Typography } from "@material-ui/core";

export class LoginForm extends Form {
  validate = false;

  state = {
    data: { email: "", password: "", remember_me: false },
    errors: {},
    error: ""
  };

  doSubmit = async () => {
    try {
      const { data } = this.state;
      await auth.login(data.email, data.password, data.remember_me);

      const { state } = this.props.location;
      if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        window.location = "/w"
      } else {
        window.location = state ? state.from.pathname : process.env.REACT_APP_BASE_URL;
      }

    } catch (ex) {
      if (ex.response && ex.response.status === 401) {
        this.setState({ error: "Hibás felsználónév vagy jelszó" });
      } else {
        this.setState({ error: "Átmeneti hiba, kérjük próbálja meg pár perc múlva!" });
      }
    }
  };

  render() {
    if (auth.getCurrentUser()) return <Redirect to="/w" />;

    return (
      <div>
        <h1>Belépés</h1>

        {this.state.error === "" ? null : (<Typography color="error">{this.state.error}</Typography>)}
        <form onSubmit={this.handleSubmit}>
          {this.renderInput("email", "E-mail")}
          {this.renderInput("password", "Jelszó", "password")}
          {this.renderCheckbox("remember_me", "Emlékezz rám")}
          <br />
          {this.renderButton("Belépés")}
          <br /><br />
          <Button component={props => <NavLink to="/w/forgot-password" {...props} />}>Elfelejtett jelszó</Button>
        </form>
      </div>
    );
  }
}

export default LoginForm;
